@if (!isHTML) {
  <span>
    {{ text | translate: jsonKey:this.sessionService.session.language : false | async }}
  </span>
}
@if (isHTML) {
  <div [innerHTML]="text| translate: jsonKey:this.sessionService.session.language : true | async | pipeSafeHTML  ">
  </div>
}